import {
  CREATE_LICENSE,
  MANAGE_LICENSE,
  SUPER_ADMIN_SHOW_CREATION_ERR,
  SUPER_ADMIN_SHOW_MANAGE_ERR,
  SUPER_ADMIN_SHOW_CREATION_SUCCESS,
  SUPER_ADMIN_SHOW_MANAGE_SUCCESS,
  SUPER_ADMIN_HIDE_MODAL,
} from '../types';

interface ConfirmationState {
  type: typeof CREATE_LICENSE | typeof MANAGE_LICENSE;
  visible: boolean;
  failed: boolean;
  actions: unknown[];
}

interface ConfirmationAction {
  type: string;
  actions: unknown[];
}

const initialState: ConfirmationState = {
  type: CREATE_LICENSE,
  visible: false,
  failed: false,
  actions: [],
};

export default (
  state: ConfirmationState = initialState,
  action: ConfirmationAction,
): ConfirmationState => {
  switch (action.type) {
    // Show errors:
    case SUPER_ADMIN_SHOW_CREATION_ERR:
      return {
        type: CREATE_LICENSE,
        visible: true,
        failed: true,
        actions: action.actions,
      };
    case SUPER_ADMIN_SHOW_MANAGE_ERR:
      return {
        type: MANAGE_LICENSE,
        visible: true,
        failed: true,
        actions: action.actions,
      };

    // Show successes:
    case SUPER_ADMIN_SHOW_CREATION_SUCCESS:
      return {
        type: CREATE_LICENSE,
        visible: true,
        failed: false,
        actions: [],
      };
    case SUPER_ADMIN_SHOW_MANAGE_SUCCESS:
      return {
        type: MANAGE_LICENSE,
        visible: true,
        failed: false,
        actions: [],
      };

    // Hide modal:
    case SUPER_ADMIN_HIDE_MODAL:
      return initialState;

    default:
      return state;
  }
};
